import React, { Component } from "react";
import { Modal, Form, Row, Col, Button, Table, Switch, Tooltip, DatePicker } from "antd";
import "./Form.css";
import numeral from "numeral";
import moment from "moment-timezone"; // VALIDAR DATAS
import { maskDate } from "../utils/Masker";
import axios from "axios";
import InputForm from "./InputForm";
import CtaCorrenteFrame from './CtaCorrenteFrame';

const { Item: ItemForm } = Form;
const { Column } = Table;

export default class CaixaCadListaForm extends Component {
  state = {
    listaRegistros: [],

    carregando: false,
    pagina: 1,
    limite: 10,
    total: 0,

    registro: {
      cx_data: moment().format('DD/MM/YYYY'),
      cx_cta_corrente: { key: '0' },
    },
  };


  componentDidUpdate(propsAnterior) {
    const { total, pagina, limite } = this.state;
    if (this.props.registroCaixas !== propsAnterior.registroCaixas) {
      this.setState({
        registro: this.props.registroCaixas,
      });
      this.getListaRegistros();
    }
    const ultimaPagina = Math.ceil(total / limite);
    if (pagina > 1 && pagina > ultimaPagina) {
      this.setState({
        pagina: ultimaPagina,
      }, this.getListaRegistros)
    }
  }

  getListaRegistros = () => {
    this.setState({ listaRegistros: [], carregando: true });
    const { pagina, limite } = this.state;
    axios
      .get('/caixas', {
        params: {
          page: pagina,
          limite: limite,
        }
      })
      .then(response => {
        const { data, total, current_page, per_page } = response.data;
        this.setState({
          listaRegistros: data,
          carregando: false,
          total: total,
          pagina: current_page,
          limite: Number(per_page),
        });
      })
      .catch(erro => {
        console.warn(erro);
        this.setState({
          carregando: false,
        });
      });
  };

  onOK = () => {
    const dataAtual = moment().format('YYYY-MM-DD');
    const dataEmiss = moment(this.state.registro.cx_data, 'DD/MM/YYYY').format('YYYY-MM-DD');
    if (dataEmiss > dataAtual) {
      Modal.warning({ title: 'Aviso!', content: 'Data do Caixa maior que data atual.' });
      return;
    }
    if ((!this.state.registro.cx_cta_corrente) || (this.state.registro.cx_cta_corrente.key === '0') || (this.state.registro.cx_cta_corrente.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Conta Corrente' });
      return;
    }

    this.setState({ salvando: true })

    this.state.registro.cx_data = moment(this.state.registro.cx_data, 'DD/MM/YYYY').format('YYYY-MM-DD');
    this.state.registro.cx_cta_corrente = this.state.registro.cx_cta_corrente.key;

    axios.post('/caixas/store', this.state.registro)
      .then(response => {

        this.setState({
          formVisivel: false,
          salvando: false,
          carregando: false,
          registro: {
            cx_data: moment().format('DD/MM/YYYY'),
            cx_cta_corrente: { key: '0' },
          },
        },
          this.getListaRegistros()
        )

      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          salvando: false,
          registro: {
            cx_data: moment().format('DD/MM/YYYY'),
            cx_cta_corrente: { key: '0' },
          },
        })

        if (error.response.status === 412) {
          Modal.error({ title: 'Atenção', content: error.response.data, okText: 'OK', })
        } else {
          Modal.error({ title: 'Falha - Atenção!', content: 'Não foi possível gravar esse caixa. ' + error.response.data, okText: 'OK', })
        }

      })

  };

  onExcluirClick = registro => {
    Modal.confirm({
      title: 'Confirmação de Exclusão',
      content: `Deseja excluir este caixa?`,
      okText: 'Sim',
      cancelText: 'Não',
      onOk: () => {
        this.setState({ carregando: true });
        axios.delete(`/caixas/delete/${registro.cx_idf}`)
          .then(response => {
            const { listaRegistros, total } = this.state;
            const registroIndex = listaRegistros.findIndex(tar => tar.cx_idf === registro.cx_idf)
            listaRegistros.splice(registroIndex, 1);
            this.setState({
              listaRegistros: listaRegistros.concat([]),
              total: total - 1,
              carregando: false,
            })

          }).catch(error => {
            console.error(error.response);
            this.setState({
              carregando: false,
            })
          })
      }
    })
  };

  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({
      [id]: value
    });
  };

  onChangeCtaCorrente = event => {
    const { registro } = this.state;
    registro['cx_cta_corrente'] = event.cx_cta_corrente;
    this.setState(event);
  }

  onDateChange = event => {
    // console.log('onDateChange', moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY'));
    const { registro } = this.state;
    registro['cx_data'] = String(moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY'));
    this.setState({ cx_data: String(moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY')) });
  }


  renderData = (data) => {
    if (data) {
      const dataMoment = moment(data);
      return (
        <span>
          {dataMoment.format('DD/MM/YYYY')}
        </span>
      )
    } else {
      return (
        <span></span>
      )
    }
  }

  renderValor = (vlr) => {
    return (
      <span> {numeral(parseFloat(vlr)).format('0,000.00')} </span>
    );
  };

  renderAcoes = (text, registro) => {
    return (
      <Tooltip title="Excluir">
        <Button type="danger" onClick={() => this.onExcluirClick(registro)} icon="delete" />
      </Tooltip>
    );
  };

  onAtivaChange = (registro, ativar) => {
    this.setState({
      carregando: true
    })
    let request;

    if (ativar) {
      request = axios.put(`/caixas/ativa/${registro.cx_idf}/1`)
    } else {
      request = axios.put(`/caixas/ativa/${registro.cx_idf}/0`)
    }

    request.then(response => {
      registro.cx_situacao = ativar;
      this.setState({
        listaRegistros: this.state.listaRegistros.concat([]),
        carregando: false
      })
    }).catch(error => {
      console.error(error.response);
      this.setState({
        carregando: false
      })
    })
  };

  renderAtiva = (cx_situacao, registro) => {
    return (
      <Switch
        checkedChildren="Aberto"
        unCheckedChildren="Fechado"
        checked={cx_situacao ? true : false}
        onChange={ativar => this.onAtivaChange(registro, ativar)}
      />
    );
  };


  onTabelaChange = (pagination => {
    this.setState({
      pagina: pagination.current,
      limite: pagination.pageSize,
    },
      this.getListaRegistros)
  })




  render() {
    const { onCancelarCadListaClick, visivel } = this.props;
    const { listaRegistros, total, pagina, limite, carregando, salvando } = this.state;
    const { cx_data, cx_cta_corrente } = this.state.registro;

    // console.log('CaixaCadListaForm.this.state: ', this.state);

    return (
      <Modal
        title={"Controle de Caixas"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarCadListaClick}
        footer={null}
        width={"60%"}
        style={{ top: 10 }}
      >

        <Row style={{ marginTop: -10 }}>
          <Col xs={24} sm={6} style={{ marginTop: 4 }} className="camposEspacoDireita">
            <span>Data</span>
            <DatePicker
              onChange={this.onDateChange}
              format="DD/MM/YYYY"
              showToday={true}
              allowClear={false}
              value={moment(cx_data, "DD/MM/YYYY", true)}
              style={{ width: "100%" }}
            />
          </Col>
          <Col xs={12} sm={15} style={{}} className="camposEspacoDireita">
            <CtaCorrenteFrame
              label="Conta Corrente"
              id="cx_cta_corrente"
              value={cx_cta_corrente}
              width={"80%"}
              onChange={this.onChangeCtaCorrente}
            />
          </Col>

          <Col xs={2} style={{ marginTop: 20 }}>
            <Button
              type="primary"
              htmlType="button"
              onClick={this.onOK}
              className="btn-salvar"
              loading={salvando}
              style={{ width: 130 }}
            >
              Gravar
            </Button>
          </Col>
        </Row>


        <Row>
          <div style={{ height: 520 }}>
            <Table
              pagination={{
                total: total,
                pageSize: limite,
                current: pagina,
                pageSizeOptions: ['10', '20', '30', '40'],
                showSizeChanger: true,
              }}
              onChange={this.onTabelaChange}
              loading={{
                spinning: carregando,
                tip: 'Carregando. Aguarde...',
                size: "large"
              }}
              dataSource={listaRegistros}
              rowKey={(registro => registro.cx_idf)}
            >
              <Column
                key="cx_data"
                dataIndex="cx_data"
                title="Data"
                render={this.renderData}
                width={100}
                align="left"
                className="listaCadastro"
              />
              <Column
                key="cc_descricao"
                dataIndex="cc_descricao"
                title="Conta Corrente"
                width={400}
                align="left"
                className="listaCadastro"
              />
              <Column
                key="cx_situacao"
                dataIndex="cx_situacao"
                title="Situação"
                render={this.renderAtiva}
                width={80}
                align="center"
                className="listaCadastro"
              />
              <Column
                key="acoes"
                title=""
                render={this.renderAcoes}
                width={30}
                align="center"
                className="listaCadastro"
              />
            </Table>
          </div>
        </Row>

        <div>
          <div className="divider-form" />
          <ItemForm>
            <Row>
              <Col xs={24}>
                <Button
                  htmlType="button"
                  onClick={onCancelarCadListaClick}
                  className="btn-fechar"
                >
                  Fechar
                </Button>
              </Col>
            </Row>
          </ItemForm>
        </div>


      </Modal >



    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CaixaCadListaForm.js